module.exports = __webpack_public_path__ + "static/media/ivan.2cdb452c.jpg";